module.exports = __webpack_public_path__ + "82876254.woff2";